import { create } from "zustand";
import { persist } from "zustand/middleware";

const useProducts = create<any>()(
	persist(
		(set) => ({
			allProducts: [],
			next: null,
			resultsFound: null,
			setNext: (data) =>
				set(() => ({
					next: data,
				})),
			setResultsFound: (data) =>
				set(() => ({
					resultsFound: data,
				})),
			setAllProducts: (data) =>
				set(() => ({
					// allProducts: { ...state.customerData, ...data },
					allProducts: data,
				})),
		}),
		{
			name: "daily-sale-shop-products",
		}
	)
);

export default useProducts;
